import TabsHeader from 'components/UI/TabsHeader/TabsHeader';
import { FunctionComponent } from 'react';
import { TabType } from '../Checkout';
import styles from './Tabs.module.css';

interface TabsProps {
    title?: string;
    tabId: string;
    onSelect: (tabId: TabType) => void;
}

export const detailsTabId = 'details';
export const transactionsTabId = 'transactions';

export const Tabs: FunctionComponent<TabsProps> = props => {
    const tabOptions = [
        { id: detailsTabId, name: props.title ?? 'Details' },
        { id: transactionsTabId, name: 'Transactions' }
    ];

    const selectTabHandler = (tabId: string) => {
        props.onSelect(tabId as TabType);
    };

    return (
        <TabsHeader
            className={styles.tabsHeader}
            tabs={tabOptions}
            selectedTabId={props.tabId}
            onClick={selectTabHandler}
        />
    );
};

export default Tabs;
